import {timeFromCreated} from 'utilities/helper/timeFromCreated';
import AuctionCard from '../item/auction';
import SaleCard from '../item/sale';
import PrepaymentCard from '../item/prepayment';
import SimpleCard from '../item/simple';

export const cardConvertor: Record<
  string,
  (
    post: IGetPostDetail,
    app: string,
    handleBokmarks: (bookmarks: IGetPostDetail) => void,
  ) => JSX.Element
> = {
  auction: (post, app, handleBokmarks) => {
    return (
      <AuctionCard
        guid={post.guid}
        main_image={post?.main_image}
        title={post.title}
        suggestions={post.suggestions}
        expire_date={post.auction ? post.auction.expire_date : '0'}
        type={post.type}
        app={app}
        post={post}
        createdDate={timeFromCreated(post.created_at)}
        handleBokmarks={handleBokmarks}
      />
    );
  },
  sale: (post, app, handleBokmarks) => {
    return (
      <SaleCard
        guid={post.guid}
        main_image={post?.main_image}
        title={post.title}
        negotiated_price={post.negotiated_price}
        price={post.price}
        expire_date={post.sale ? post.sale.expire_date : '0'}
        type={post.type}
        app={app}
        post={post}
        createdDate={timeFromCreated(post.created_at)}
        handleBokmarks={handleBokmarks}
      />
    );
  },
  prepayment: (post, app, handleBokmarks) => {
    return (
      <PrepaymentCard
        main_image={post?.main_image}
        title={post.title}
        guid={post.guid}
        negotiated_price={post.negotiated_price}
        price={post.price}
        expire_date={post.prepayment ? post.prepayment.expire_date : '0'}
        existing={post.cultivation ? post.cultivation.area : 0}
        type={post.type}
        app={app}
        post={post}
        createdDate={timeFromCreated(post.created_at)}
        handleBokmarks={handleBokmarks}
      />
    );
  },
  simple: (post, app, handleBokmarks) => {
    return (
      <SimpleCard
        main_image={post?.main_image}
        negotiated_price={post.negotiated_price}
        price={post.price}
        guid={post.guid}
        title={post.title}
        state={post.state && post.state.name}
        city={post.city && post.city.name}
        type={post.type}
        app={app}
        post={post}
        createdDate={timeFromCreated(post.created_at)}
        handleBokmarks={handleBokmarks}
      />
    );
  },
};
